import { render, staticRenderFns } from "./TradingOrderBookFilters.vue?vue&type=template&id=3f7ea437&"
import script from "./TradingOrderBookFilters.vue?vue&type=script&lang=js&"
export * from "./TradingOrderBookFilters.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports